import {WhiteCard} from "../_components/WhiteCard";
import {ABOverlayPopover} from "../../_components/CustomOverlayTooltip";
import {Badge} from "react-bootstrap";
import {TableLikeText} from "../../_components";
import {stateMap} from "../DashboardDevice";
import {DeviceProject} from "../../../utils2/maps";
import {useTopicSSE} from "../../../hooks/useTopicSSE";
import {SseTopics} from "../../../context/SSEContext";
import {useMemo} from "react";

export function StreamSection({device}) {
    const online = useTopicSSE(SseTopics.Online)
    const stream = useTopicSSE(SseTopics.Stream)
    const next = useTopicSSE(SseTopics.Next)
    const live = useTopicSSE(SseTopics.Live)

    const liveMsg = useMemo(() => {
        const match = live?.msg.match(/StreamTitle='(.*?)';/);
        const result = match ? match[1] : null;
        return result || "Not available";
    }, [live])

    return <>
        {online && next?.state === 3 && (device?.device_project === DeviceProject.StandardEth ||
            device?.device_project === DeviceProject.MicroEth ||
            device?.device_project === DeviceProject.NanoEth) && <WhiteCard className="flex-grow-1">
            <StreamDetails stream={stream} live={liveMsg}/>
        </WhiteCard>}
    </>
}

function StreamDetails({stream, live}) {
    const isFailed = stateMap[stream?.state] === "Failed"

    const ctx = stream?.ctx

    let badgeBg = "";
    switch (stream?.state) {
        case 0:
        case 1:
        case 3:
            badgeBg = "secondary"
            break;
        case 2:
            badgeBg = "success"
            break;
        case 4:
            badgeBg = "danger"
            break;
        default:
            badgeBg = "warning"
            break;
    }

    // const badgeBg = stream?.state === 0 || stream?.state === 1 || stream?.state === 3 ? "secondary" :
    //     stream?.state === 2 ? "success" :
    //         stream?.state === 4 ? "danger" : "warning"


    const mimeMap = {
        0: "Unknow",
        1: "ACC",
        2: "MP3",
        3: "OGG Vorbis",
        4: "WAV",
        5: "FLAC",
        6: "MIDI"
    }

    return <>

        <ABOverlayPopover buttonLabel={<Badge bg={badgeBg} className="mb-2">
            <div className="d-flex align-items-center gap-2">PLAYBACK <i className="fs-5 bi bi-broadcast"/></div>
        </Badge>} headerText="Additional details">
            <div>
                <TableLikeText titleColor="text-light" title="State" value={stateMap[stream?.state]}/>
                <TableLikeText titleColor="text-light" title="Source" value={ctx?.fail ? "Fail over" : "Main"}/>
                <TableLikeText titleColor="text-light" title="Host" value={ctx?.host}/>
                <TableLikeText titleColor="text-light" title="Port" value={ctx?.port}/>
                <TableLikeText titleColor="text-light" title="TLS" value={ctx?.tls}/>
                <TableLikeText titleColor="text-light" title="Auth." value={ctx?.auth ? "Authenticated" : "Open"}/>
                {ctx?.sr > 0 && <TableLikeText titleColor="text-light" title="Samplerate" value={`${ctx?.sr} Hz`}/>}
                {ctx?.br > 0 && <TableLikeText titleColor="text-light" title="Bitrate" value={`${ctx?.br} kbps`}/>}
                <TableLikeText titleColor="text-light" title="MIME" value={mimeMap[ctx?.mime]}/>
                <TableLikeText titleColor="text-light" title="Msg" value={ctx?.msg}/>
            </div>
        </ABOverlayPopover>

        <TableLikeText title="Name" value={ctx?.name}/>
        <TableLikeText title="URL" value={
            <a href={ctx?.url} target="_blank"
               className="link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">{ctx?.url}
            </a>}/>
        <TableLikeText title="Genre" value={ctx?.gnr}/>
        <TableLikeText title="Description" value={ctx?.dsc}/>
        <TableLikeText title="Advertised" value={ctx?.adv ? "Yes" : "No"}/>
        <TableLikeText title="Live" value={live}/>
        {ctx?.playing && <TableLikeText title="Now playing" value={ctx?.playing}/>}
        {isFailed && <TableLikeText title="Info" value={ctx?.msg}/>}
    </>
}